import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminKioskVerifyLayout.styles';
import {
  AdminHeader,
  AdminFooter,
  AdminSideSlides,
  AdminKioskVerifyMain,
  KioskIdelScreen
} from '..';
import { injectIntl, defineMessages } from 'react-intl';
import AdminVideo from '../AdminImgCapture/AdminVideo';
import { connect } from 'react-redux';

const messages = defineMessages({
  ScanCodeToVerify: {
    id: 'Admin.Verify.ScanCodeToVerify',
    defineMessages: 'Scan the stock code to verify.'
  },
  VerifyOrder: {
    id: 'Admin.Verify.VerifyOrder',
    defineMessages: 'Verify Order'
  }
});

export class AdminKioskVerifyLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle:
      this.props && this.props.intl.formatMessage(messages.ScanCodeToVerify),
    subTitle: this.props && this.props.intl.formatMessage(messages.VerifyOrder),
    height: 300
  };

  render() {
    const { classes } = this.props;
    const isRemoveIdelTimerEnabled = localStorage.getItem('removeIdelTimer');
    return (
      <div className={classNames(classes.container)}>
        <AdminVideo />
        <AdminHeader myLogoheight={this.state.height} />
        <AdminSideSlides
          pageTitle={this.state.subTitle}
          subTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminKioskVerifyMain />
        <AdminFooter customFooterBottom="0%" />
        {isRemoveIdelTimerEnabled === 'false' ? <KioskIdelScreen /> : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const kiosk = state.get('kiosk');
  return { ...kiosk };
};

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(injectIntl(AdminKioskVerifyLayout))
);
